import OBildingLabels from './o-building-labels';

export default OBildingLabels;